import { useSelector } from "react-redux";
import { GnbMenuItem } from "./GnbMenuItem"

export const GnbMenu = ({gnbCode="", onClick=f=>f})=>{
    const config = useSelector(state => state.config);
    const auth = useSelector(state => state.auth);

    if(auth.restricted)return null;

    return (
        <ul className="menu_list clear">
            <GnbMenuItem path="/reading/test" code="reading" onClick={onClick}>독서력진단</GnbMenuItem>
            <GnbMenuItem path="/recommend" code="recommend" onClick={onClick}>추천도서</GnbMenuItem>
            <GnbMenuItem path="/book" code="book" onClick={onClick}>도서찾기</GnbMenuItem>
            <GnbMenuItem path="/bookreport" code="bookreport" onClick={onClick}>독서감상문</GnbMenuItem>
            <GnbMenuItem path="/picture" code="picture" onClick={onClick}>독서화</GnbMenuItem>
            <GnbMenuItem path="/photo" code="photo" onClick={onClick}>독서사진</GnbMenuItem>
            <GnbMenuItem path="/video" code="video" onClick={onClick}>독서영상</GnbMenuItem>
            <GnbMenuItem path="/userbook" code="userbook" onClick={onClick}>나도작가다</GnbMenuItem>
            { config.useDongwha &&
                <GnbMenuItem path="/donghwa" code="donghwa" onClick={onClick}>동화서당</GnbMenuItem> 
            }
        </ul>
    )
}